import { createApp } from "vue";
import App from "./App.vue";
import { Button, Dialog, Field, List, SwipeCell, Loading, Toast, Search, Popup, Uploader, Picker, Checkbox, CheckboxGroup, RadioGroup } from "vant";
import "vant/lib/index.css"; //按需加载无法引对话框的

import DataVVue3 from "@kjgl77/datav-vue3";

import axios from "./util/axios";
import res from "./util/res";
import util from "./util/util";

import store from "./store/index";
import router from "./router/index";
import editDialog from "@/components/editDialog";

import "@vant/touch-emulator";

const app = createApp(App);

app.use(Button);
app.use(Toast);
app.use(Dialog);
app.use(Field);
app.use(List);
app.use(SwipeCell);
app.use(Loading);
app.use(Search);
app.use(Popup);
app.use(Uploader);
app.use(Picker);
app.use(Checkbox);
app.use(CheckboxGroup);
app.use(RadioGroup);
app.use(editDialog);

app.use(store);
app.use(router);
app.use(DataVVue3);

import mitt from "mitt";
let emitter = mitt();

app.config.globalProperties.$util = util;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$res = res;
app.config.globalProperties.$eventBus = emitter;
app.config.globalProperties.$editDialog = editDialog;

app.config.errorHandler = (err, vm, info) => {
  if (err) {
    console.error(`Error: ${err.toString()}\nInfo: ${info}`, err, vm, info);
    Toast.fail(err.toString() || "出错啦");
  } else {
    Toast.fail("出错啦");
  }
};

window.addEventListener("unhandledrejection", (event) => {
  if (typeof event.reason == "string") {
    Toast.fail(event.reason || "出错啦");
  } else if (typeof event.reason == "object") {
    if (Array.isArray(event.reason)) {
      Toast.fail(event.reason[0].message);
    } else {
      Toast.fail(event.reason.message);
    }
  }
  // console.error("~~~~~~",event)
  return false;
});

app.mount("#app");
